import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, Calendar, CheckSquare, PenTool, Shield } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    icon: <BookOpen className="w-8 h-8 text-accent" data-id="element-169" />,
    title: 'Guía S.O.S. Sueño Infantil',
    desc: '(Ebook PDF completo).'
  }, {
    icon: <Clock className="w-8 h-8 text-accent" data-id="element-170" />,
    title: 'El Protocolo de 90 Segundos',
    desc: 'Paso a paso para manejar los despertares nocturnos.'
  }, {
    icon: <Calendar className="w-8 h-8 text-accent" data-id="element-171" />,
    title: 'Mapa de Ventanas de Sueño',
    desc: 'Por edad (4 a 24 meses).'
  }, {
    icon: <CheckSquare className="w-8 h-8 text-accent" data-id="element-172" />,
    title: 'Checklist',
    desc: 'Habitación a Prueba de Despertares.'
  }, {
    icon: <PenTool className="w-8 h-8 text-accent" data-id="element-173" />,
    title: 'Diario de Sueño de 7 días',
    desc: 'Para identificar patrones ocultos.'
  }, {
    icon: <Shield className="w-8 h-8 text-accent" data-id="element-174" />,
    title: 'Guía de Crisis y Regresiones',
    desc: 'Qué hacer a los 4, 8 y 18 meses.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-dark-100 text-text-dark py-20 md:py-28 px-6" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-178">
            Todo lo que incluye
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-179"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-180">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-dark-200 p-8 rounded-2xl border border-accent/20 hover:border-accent/50 transition-colors duration-300 flex items-start space-x-6" data-id="element-181">
              <div className="shrink-0 p-3 bg-dark-100 rounded-xl border border-accent/10" data-id="element-182">
                {item.icon}
              </div>
              <div data-id="element-183">
                <h3 className="text-xl font-serif mb-2 text-white" data-id="element-184">
                  {item.title}
                </h3>
                <p className="text-text-dark/70" data-id="element-185">{item.desc}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}